module.exports = __webpack_public_path__ + "img/Import.248c69b2.svg";